import gql from 'graphql-tag';

export const STEP_FRAGMENT = gql`
  fragment StepDetail on Step {
    id
    label
    name
    color
    priority
  }
`;

export const CRM_STEP_FRAGMENT = gql`
  fragment CRMStepDetail on CRMStep {
    id
    label
    name
  }
`;

export const MINIMAL_BUSINESS_FRAGMENT = gql`
  fragment BusinessInfo on Business {
    id
    createdAt
    email
    phone
    firstName
    lastName
    recordSharedUrl
    step {
      ...StepDetail
    }
    CRMStep {
      ...CRMStepDetail
    }
    possibleSteps {
      ...StepDetail
    }
    idCRM
  }
  ${STEP_FRAGMENT}
  ${CRM_STEP_FRAGMENT}
`;

export const BUSINESS_DETAILS_FRAGMENT = gql`
  fragment BusinessDetailsInfo on Business {
    id
    idCRM
    firstName
    lastName
    createdAt
    unblockedAt
    signedByNotaryAt
    phone
    email
    estimatedMaxPurchase
    estimatedMaxLoan
    manager {
      id
      firstName
      lastName
    }
    mandatary {
      id
      firstName
      lastName
    }
    apa {
      id
      firstName
      lastName
      enseigneName
      agencies {
        name
      }
    }

    step {
      id
      label
      name
    }

    CRMStep {
      id
      label
      name
    }

    possibleSteps {
      id
      label
      name
    }

    remuneration {
      id
      clientHonorary
      bankCommission
      bank {
        id
        type
        name
      }
    }

    apaCommissions {
      id
      beneficiary {
        id
        firstName
        lastName
      }
      amount
    }

    mandaCommissions {
      id
      beneficiary {
        id
        firstName
        lastName
      }
      amount
    }
  }
`;
